"use client";

import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import { Partytown } from "@builder.io/partytown/react";
interface AnalyticsProps {
  profile: any;
}
const DEFAULT_ANALYTICS_CONSENT_CATEGORY = "C0002";

// Hotfix: consent-gating (useResolvedAlgoliaConsent) removed — it was
// dropping GTM/Aptrinsic for a large share of visitors due to a
// consent-detection race. GTM/Aptrinsic load unconditionally again
// whenever a gtmId is configured, matching pre-9/17 behavior.
const Analytics = t0 => {
  const $ = _c(7);
  const {
    profile
  } = t0;
  const gtmId = profile?.NEXT_PUBLIC_GTM_ID;
  if (!gtmId) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Partytown lib="/~partytown/" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Script id="_next-gtm-init" strategy="lazyOnload" dangerouslySetInnerHTML={{
      __html: "\n            window.dataLayer = window.dataLayer || [];\n            window.dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});\n          "
    }} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  let t4;
  if ($[2] !== t3) {
    t4 = <Script id="_next-gtm" strategy="lazyOnload" src={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Script id="gainsight-script" strategy="lazyOnload" dangerouslySetInnerHTML={{
      __html: `
            const appMode = "${process.env.NEXT_PUBLIC_ECOM_ENV}";
            const aptrinsicConfig = {};
            let aptrinsicId;
            switch (appMode) {
                case 'prod':
                    aptrinsicId = 'AP-UNM677VB2XAD-2';
                    break;
                case 'dev':
                case 'local':
                    aptrinsicId = 'AP-UNM677VB2XAD-2-2';
                    break;
                case 'qa':
                    aptrinsicId = 'AP-UNM677VB2XAD-2-3';
                    break;
                case 'sit':
                    aptrinsicId = 'AP-UNM677VB2XAD-2-4';
                    break;
                default:
                    aptrinsicId = 'AP-UNM677VB2XAD-2-2';
            }
            (function (n, t, a, e, co) {
                var i = 'aptrinsic';
                (n[i] =
                    n[i] ||
                    function () {
                        (n[i].q = n[i].q || []).push(arguments);
                    }),
                    (n[i].p = e);
                n[i].c = co;
                var r = t.createElement('script');
                (r.async = !0), (r.src = a + '?a=' + e);
                var c = t.getElementsByTagName('script')[0];
                c.parentNode.insertBefore(r, c);
            })(
                window,
                document,
                'https://web-sdk.aptrinsic.com/api/aptrinsic.js',
                aptrinsicId,
                aptrinsicConfig
            );
            `
    }} />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4) {
    t6 = <>{t1}{t2}{t4}{t5}</>;
    $[5] = t4;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
export default Analytics;